import { apolloClient } from '@/graphql/client';
import { createSong } from '@/graphql/mutations';
import store from '@/store';
import { actionSheetController, toastController } from '@ionic/vue';
import router from '@/router';
import { Filesystem } from '@capacitor/filesystem';

export async function processSharedAudioFile(fileUrl: string) {
  const filename = decodeURIComponent(
    fileUrl?.split('/')[fileUrl?.split('/').length - 1],
  );

  let isLoading = false;
  let fileBlob: Blob;

  try {
    const readFile = await Filesystem.readFile({
      path: fileUrl,
    });
    const buffer = base64ToArrayBuffer(readFile.data as string);
    fileBlob = new Blob([buffer]);
  } catch (err) {
    showErrorMessage(err);
    return;
  }

  const actionSheet = await actionSheetController.create({
    header: `Import Audio${filename ? `: ${filename}` : ''}`,
    buttons: [
      {
        text: 'Create a new song',
        async handler() {
          isLoading = true;

          // Create the song
          let createSongRes;
          try {
            createSongRes = await apolloClient.mutate({
              mutation: createSong,
              variables: {
                title: filename,
              },
            });
          } catch (err) {
            isLoading = false;
            showErrorMessage(err);
            return;
          }

          // start the file upload
          store.dispatch('startFileUpload', {
            selectedFile: fileBlob,
            filename,
            songId: createSongRes.data.createSong.id,
          });

          isLoading = false;
          // send them over to the song
          router.push(`/song/${createSongRes.data.createSong.id}?edit=true`);
        },
        cssClass: `light-action-sheet-button ${
          isLoading ? 'action-sheet-button-disable' : ''
        }`,
      },
      // Temporarily disabled until we figure out why its broken
      // {
      //   text: 'Add version to existing song',
      //   async handler() {
      //     const modal = await modalController.create({
      //       component: AddToExistingSong,
      //       componentProps: {
      //         fileBlob,
      //         filename,
      //       },
      //     });
      //     await modal.present();
      //   },
      //   cssClass: 'light-action-sheet-button',
      // },
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'light-action-sheet-button',
      },
    ],
  });
  await actionSheet.present();
}

async function showErrorMessage(err: any) {
  const message = err.message.includes('limit')
    ? "You're out of space! Visit account settings for more info."
    : 'Sorry! We had trouble creating the song. Please try again later.';

  const toast = await toastController.create({
    header: 'Uh oh!',
    message,
    buttons: [
      {
        text: 'Ok',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        },
      },
    ],
  });
  await toast.present();
}

function base64ToArrayBuffer(base64: string) {
  const binaryString = window.atob(base64); // Decode base64
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}
